import { render, staticRenderFns } from "./TagsLimitManagement.vue?vue&type=template&id=93dd0bcc&scoped=true&"
import script from "./TagsLimitManagement.vue?vue&type=script&lang=js&"
export * from "./TagsLimitManagement.vue?vue&type=script&lang=js&"
import style0 from "./TagsLimitManagement.vue?vue&type=style&index=0&id=93dd0bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dd0bcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
